import * as React from 'react';
import * as style from './StickyBlock.css';

export interface IStickyBlockProps extends React.PropsWithChildren {
  dataMark?: string;
  tag?: 'div' | 'section' | 'p' | 'span';
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}

export class StickyBlock extends React.Component<IStickyBlockProps> {
  public render() {
    const {
      tag: Tag = 'div',
      dataMark = 'StickyBlock',
      children,
      top = 0,
      bottom = 'auto',
      left = 'auto',
      right = 'auto',
    } = this.props;

    return (
      <Tag
        style={{
          top,
          bottom,
          left,
          right,
        }}
        data-mark={dataMark}
        className={style['layout']}
      >
        {children}
      </Tag>
    );
  }
}
